import React, { useEffect } from 'react';
import { AlertCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { DashboardApi } from '../../../apis/DashboardApi';

interface AccountSuspensionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AccountSuspensionModal: React.FC<AccountSuspensionModalProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [subscription, setSubscription] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    if (isOpen) {
      fetchSubscriptionData();
    }
  }, [isOpen]);

  const fetchSubscriptionData = async () => {
    try {
      setLoading(true);
      const response: any = await DashboardApi.getUserSubscription();
      if (response?.data?.status === 'success') {
        setSubscription(response.data.data.subscription);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching subscription:', error);
      setLoading(false);
    }
  };

  const handleRenewClick = () => {
    onClose();
    navigate('/upgrade');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full overflow-hidden">
        <div className="bg-red-500 p-5">
          <div className="flex items-center">
            <AlertCircle className="text-white mr-3" size={24} />
            <h3 className="text-lg font-bold text-white">Account Suspended</h3>
          </div>
        </div>
        
        <div className="p-5">
          <p className="mb-4">
            Your account has been suspended due to an expired subscription. To regain access to all features, 
            please renew your subscription now.
          </p>
          
          {!loading && subscription && (
            <div className="bg-gray-50 p-4 rounded-lg mb-4">
              <h4 className="font-medium text-gray-700 mb-2">Subscription Details</h4>
              <div className="text-sm">
                <div className="flex justify-between mb-1">
                  <span className="text-gray-500">Plan:</span>
                  <span>{subscription.plan_name || 'N/A'}</span>
                </div>
                <div className="flex justify-between mb-1">
                  <span className="text-gray-500">Status:</span>
                  <span className="text-red-500 font-medium">Suspended</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Expired on:</span>
                  <span>
                    {subscription.next_billing_date
                      ? new Date(subscription.next_billing_date).toLocaleDateString()
                      : 'N/A'}
                  </span>
                </div>
              </div>
            </div>
          )}
          
          <div className="flex justify-end gap-3">
            {/* <button
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
            >
              Close
            </button> */}
            <button
              onClick={handleRenewClick}
              className="px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600"
            >
              Renew Subscription
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSuspensionModal;